<template>
  <div class="study-layout">
    <div class="content-container">
      <LeftPane>
        <ReportTableOfContents :reportDetails="reportDetails" @selectSectionHandler="onSelectSection" :selectedSection="selectedSection" @selectPageHandler="onSelectPage" :selectedPage="selectedPage" :selectedSlide="selectedSlide" @pageVisibilityChanged="onPageVisibilityChanged" @editModeChanged="onEditModeChanged"></ReportTableOfContents>
      </LeftPane>
      <div class="right-panel">
        <div class="charts-content">
          <div class="study-content">
            <HotelReportContents :reportDetails="reportDetails" :selectedPage="selectedPage" :selectedSlide="selectedSlide" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftPane from "@/components/partials/LeftPane";
import RouteGuard from "pinnacle-lib/mixins/RouteGuard";
import { GetMixin } from "pinnacle-lib";
import ReportTableOfContents from "@/components/reports/ReportTableOfContents.vue";
import HotelReportContents from "@/components/reports/HotelReportContents.vue";

export default {
  mixins: [GetMixin],
  components: {
    ReportTableOfContents,
    HotelReportContents,
    LeftPane,
  },
  props: ['reportDetails'],
  data() {
    return {
      ids: [],
      showAlert: false,
      index: 0,
      detail: false,
      bool: false,
      showRightPane: false,
      invalidLocationModal: false,
      showInsights: false,
      showPicker: false,
      selectedSection: false,
      selectedPage:"", 
      selectedSlide: 0,
      studyLocations: [],
    };
  },
  computed: {
  },
  created() {
  },
  mounted() {
    if (!this.selectedSection && this.reportDetails.sections?.length > 0) {
      this.onSelectSection(this.reportDetails.sections[0].value);
    }
    //this.requestData();
  },
  methods: {
    onSelectSection(section) {
      console.log("onSelectSection", section);
      this.selectedSection = section;
      // update selectd page
      let match = this.reportDetails.sections.find(s => s.value == section);
      this.selectedPage = match.pages[0].value;
      this.selectedSlide = match.pages[0].slide;
    },
    onSelectPage(page) {
      this.selectedPage = page.value;
      this.selectedSlide = page.slide;
    },
    currentSection() {
      return this.reportDetails.sections?.find(s => s.value == this.selectedSection);
    },
    selectFirstVisiblePage() {
      const section = this.currentSection();
      if (!section) return;
      const firstVisible = section.pages.find(p => !p.hidden);
      if (firstVisible && firstVisible.value !== this.selectedPage) {
        this.onSelectPage(firstVisible);
      }
    },
    onPageVisibilityChanged({ page, hidden }) {
      // If the currently selected page was just hidden, move to the next visible page.
      if (hidden && page.value === this.selectedPage) {
        this.selectFirstVisiblePage();
      }
    },
    onEditModeChanged(editMode) {
      // On leaving edit mode, ensure the selected page is not a hidden one.
      if (!editMode) {
        const section = this.currentSection();
        const selected = section?.pages.find(p => p.value === this.selectedPage);
        if (selected && selected.hidden) {
          this.selectFirstVisiblePage();
        }
      }
    },
    async requestData() {
      let id = this.$route.params.id;
      try {
        let response = await this.getFromURL(`/v2/insights/get-hotel-report/${id}`);
        this.reportDetails = response;
        
        if (this.reportDetails.sections.length > 0) {
          this.onSelectSection(response.sections[0].value);
        }
      } catch (error) {
        if (error.response && error.response.status === 404) {
          this.reportDetails = {statusCode: 404, message: "Report not found"};
        }
      }      
    },
  },
  watch: {
    reportDetails(val) {
      if (val.sections.length > 0) {
        this.onSelectSection(val.sections[0].value);
      }      
    }
  },
  beforeDestroy(){
  }
};
</script>
<style lang="scss" scoped>

.study-layout {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  position: relative;
}

.content-container {
  display: flex;
  height: 100%;
  width: 100%;
}

.study-content {
  position: relative;
  width: 100%;
  height: 100%;
}

.charts-content {
  display: flex;
  flex-direction: row;
  height: 100%;
width: 100%;
}

.right-panel {
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
}
.right-panel-datepicker{
  display: flex;
    height: 100%;
    width: 380px;
    background-color: white;
    border-left: 1px solid $border-color;
    z-index: 6;
    position: absolute;
    right: 0;
    overflow-y: auto;
}

.copyLinkMessage {
  position: absolute;
  z-index: 100001;
  display: flex;
  background-color: #2c7be5;
  width: 100%;
  height: 3.2em;
  top: 0%;
  border-radius: 0;
  border-color: transparent;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.03);
  p {
    font-family: Cerebri Sans;
    font-size: 15px;
    color: white;
    margin-left: 1.25em;
    font-weight: 100;
  }
  .copyLink-bell {
    margin-left: 1.25em;
  }
}
.placesCheckboxes{
  position: absolute;
  right: 30px;
}
.polygonErrorAlertModal {
  display: flex;
  align-items: center;
  flex-direction: column;
}
::v-deep .modal-backdrop {
  box-shadow: inset 0 0 2000px hwb(0deg 100% 0% / 50%) !important;
  background-color: rgb(22 34 68 / 50%) !important;
  backdrop-filter: blur(20px) !important;
  opacity: 1 !important;
}
</style>